<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <!-- Favicon -->
    <link rel="apple-touch-icon" href="favicon/180.png" />
    <link rel="icon" type="image/png" href="/favicon/innex.png" />

    <meta name="theme-color" content="#f5f7fa" />
    <style>
      html,
      body {
        margin: 0;
        background: rgb(245, 247, 250);
      }
    </style>
    <link rel="manifest" href="/manifest.json" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />

    <title>CompliMind</title>
    <meta name="description" content="The starting point for your organization." />
    <meta name="keywords" content="hms,emr,hospital,patient,saudia,users,invoice" />
    <meta name="author" content="CompliMind" />
  </head>

  <body>
    <noscript>You need to enable JavaScript to run this app.</noscript>
    <div id="root"></div>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
